export const articles = [
  {
    id: "top-stream-drama-rumor-0909",
    title: "顶流新剧进组第三天，路透只剩背影却冲上热搜",
    summary:
      "剧组封闭拍摄进入第三天，站姐只在深夜收工时段拍到一组背影图，社交平台的讨论量却在半天内翻了三倍。我们把当天的零散线索按时间顺序理了一遍。",
    category: "top-stars",
    categoryName: "顶流追踪",
    tags: ["路透", "数据变化", "行程"],
    author: "瓜田编辑部",
    date: "2026-09-09",
    time: "20:14",
    readCount: 48210,
    hot: 98,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20night%20cityscape%20with%20warm%20amber%20street%20lights%20and%20soft%20bokeh%2C%20moody%20atmosphere%2C%20no%20people%2C%20cinematic%20film%20grain%2C%20magazine%20cover%20aesthetic&width=1200&height=675&seq=hl-topstream-cover&orientation=landscape",
    sections: [
      {
        heading: "一、时间线：从进组到话题升温",
        paragraphs: [
          "据现场周边商户与探班账号的描述，剧组从清晨开始封闭拍摄，全天未对外开放棚区。晚间收工时段，有账号拍到一组远景背影，画面里只能辨认出戏服轮廓与随行工作人员的数量。",
          "值得注意的是，这组图片发布后并未附带任何文字说明，话题却在两小时内进入平台热榜前二十。数据曲线呈现明显的「先慢后快」形态，更像是自然扩散叠加了少量集中转发。",
        ],
      },
      {
        heading: "二、数据观察：讨论量为何翻倍",
        paragraphs: [
          "我们对比了同档期其他剧集的进组路透，普通情况下首日讨论量约在两万上下，而本次半天内达到了六万级。差异主要来自粉丝后援会的组织化转发，以及部分娱乐营销号的二次解读。",
          "需要提醒的是，讨论量并不等同于真实关注度，其中包含大量重复内容和工具号参与。建议大家理性看待榜单变化，不必以单一数据判断一部剧的走向。",
        ],
      },
      {
        heading: "三、后续看点",
        paragraphs: [
          "按以往流程，剧组通常在正式杀青前不会发布官方物料。接下来值得关注的是主演的公开行程是否与拍摄周期冲突，以及平台方何时放出首支预告。若有官方定档消息，我们会第一时间在日报栏目更新。",
        ],
      },
    ],
  },
  {
    id: "variety-guest-edit-0909",
    title: "综艺正片删减争议：嘉宾互动被剪成两种走向",
    summary:
      "同一期节目在平台正片与花絮版里呈现出不同重心，观众对比后吵成两派。我们翻看了两个版本的镜头分布，尝试还原剪辑逻辑。",
    category: "variety",
    categoryName: "综艺风波",
    tags: ["剪辑", "节目组", "对比"],
    author: "看片不喊停",
    date: "2026-09-09",
    time: "17:40",
    readCount: 31650,
    hot: 89,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20television%20studio%20interior%20with%20warm%20spotlights%20and%20colorful%20acoustic%20panels%2C%20empty%20stage%20without%20people%2C%20editorial%20photography%2C%20warm%20amber%20and%20crimson%20tones&width=1200&height=675&seq=hl-variety-cover&orientation=landscape",
    sections: [
      {
        heading: "正片与花絮的镜头差",
        paragraphs: [
          "把两个版本放在一起逐段对比后可以发现，正片把大量时长给了任务环节，而花絮则集中在休息区的闲聊。相同的一段对话，在正片里只保留了结论，在花絮里才补上了前因后果。",
          "这种处理并不罕见。综艺时长有限，节目组通常优先保证主线任务的完整，把过程性内容挪到衍生版。真正让观众产生落差的，是两版发布的时间间隔太短，导致记忆出现错位。",
        ],
      },
      {
        heading: "为什么观众会觉得「被剪辑带偏」",
        paragraphs: [
          "核心原因在于叙事的引导性。通过调整反应镜头的顺序、插入背景音乐，同一段互动可以被解读为「默契」或「尴尬」两种方向。观众先看到哪一版，往往会形成先入为主的判断。",
          "理性的做法是两版都看完再下结论。把注意力放在完整对话而非单个表情上，能大幅减少误读。",
        ],
      },
    ],
  },
  {
    id: "fashion-cover-rotation-0908",
    title: "金九封面接连官宣，时尚资源的排位开始悄悄变化",
    summary:
      "九月刊向来是时尚资源的风向标。今年几本刊物的封面人选公布后，有细心的读者发现排位逻辑和往常不太一样。",
    category: "fashion",
    categoryName: "时尚资源",
    tags: ["封面", "代言", "排位"],
    author: "衣橱观察员",
    date: "2026-09-08",
    time: "11:02",
    readCount: 22890,
    hot: 76,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20fashion%20runway%20space%20with%20draped%20fabric%20backdrop%2C%20warm%20sand%20and%20terracotta%20tones%2C%20soft%20directional%20lighting%2C%20no%20people%2C%20luxury%20editorial%20photography&width=1200&height=675&seq=hl-fashion-cover&orientation=landscape",
    sections: [
      {
        heading: "封面人选透露的信号",
        paragraphs: [
          "金九银十是时尚杂志广告投放最集中的时段，封面人选往往与品牌当季的主推资源挂钩。今年几本刊物的选择更加分散，既有长期合作的熟面孔，也有首次登上封面的新面孔。",
          "排位的变化通常滞后于实际的商务签约。也就是说，看到某个名字频繁出现在重要月份，往往意味着对应的合作在数月前就已敲定。",
        ],
      },
      {
        heading: "如何理性看「资源咖位」",
        paragraphs: [
          "粉丝圈常用封面数量、代言层级来做排序，但品牌选人的维度其实很复杂，包括受众重合度、档期、品牌调性等。单一指标很难构成完整判断。",
          "与其纠结排位，不如关注作品与商务是否匹配。长期稳定的合作，往往比一次高规格封面更能说明问题。",
        ],
      },
    ],
  },
  {
    id: "live-room-incident-0908",
    title: "直播间「口误」上热搜，选品团队的回应来了",
    summary:
      "一场常规带货直播因为一句介绍词出现争议，相关片段被反复转发。选品团队当晚发布说明，解释了流程上的时间差。",
    category: "live",
    categoryName: "带货直播",
    tags: ["直播", "选品", "回应"],
    author: "下单前先看",
    date: "2026-09-08",
    time: "22:31",
    readCount: 27340,
    hot: 81,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20live%20streaming%20setup%20with%20ring%20light%20and%20microphone%20on%20warm%20wooden%20table%2C%20cozy%20indoor%20evening%20light%2C%20no%20people%2C%20editorial%20product%20photography%20with%20amber%20tones&width=1200&height=675&seq=hl-live-cover&orientation=landscape",
    sections: [
      {
        heading: "事件经过",
        paragraphs: [
          "当晚直播进行到中场时，主播在介绍一款商品的库存状态时表述不够准确，评论区随即出现讨论。由于直播是实时进行，问题在几分钟后才被后台注意到。",
          "直播结束后，选品团队发布了一条简短说明，指出实际库存以商品页为准，直播中的口播属于临场发挥，未经过完整校对。",
        ],
      },
      {
        heading: "给消费者的三条提醒",
        paragraphs: [
          "第一，下单前以商品详情页的参数为准，不要只听口播。第二，保留订单截图与直播回放链接，遇到问题更方便沟通。第三，对「限时限量」类话术保持冷静，先确认自己是否真的需要。",
        ],
      },
    ],
  },
  {
    id: "film-tv-cast-change-0907",
    title: "临开机换角？影视项目的选角变动比想象中更常见",
    summary:
      "某项目在官宣阵容前临时调整了配角人选，引发一波猜测。其实在行业里，开机前后的人员调整属于常规操作。",
    category: "film-tv",
    categoryName: "影视剧透",
    tags: ["选角", "开机动向", "剧组"],
    author: "剧本围读室",
    date: "2026-09-07",
    time: "15:20",
    readCount: 19870,
    hot: 72,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20empty%20film%20set%20with%20camera%20rig%20and%20warm%20practical%20lights%2C%20wooden%20backdrop%2C%20no%20people%2C%20cinematic%20warm%20amber%20tones%2C%20editorial%20photography&width=1200&height=675&seq=hl-filmtv-cover&orientation=landscape",
    sections: [
      {
        heading: "换角背后的常见原因",
        paragraphs: [
          "档期冲突是最主要的原因。演员的行程通常提前三到六个月排定，一旦前一项目延期，就会连带影响后续进组时间。此外还有角色调整、预算变化、演员与角色契合度重新评估等因素。",
          "所以「临开机换角」未必意味着负面事件，多数情况下只是排期重新对齐的结果。",
        ],
      },
      {
        heading: "观众可以关注什么",
        paragraphs: [
          "与其追逐未经证实的猜测，不如关注官方公示的组讯与最终定妆物料。真正影响成片质量的，是剧本完成度、拍摄周期和制作班底，而非某一次人员调整。",
        ],
      },
    ],
  },
  {
    id: "music-copyright-0907",
    title: "翻唱授权引讨论：一首歌的版权到底经过几道手续",
    summary:
      "一段舞台翻唱视频被下架后，关于授权流程的讨论热闹起来。我们梳理了一首歌从创作到公开演唱需要经过的授权环节。",
    category: "music",
    categoryName: "音乐圈事",
    tags: ["版权", "翻唱", "授权"],
    author: "耳机里的编辑部",
    date: "2026-09-07",
    time: "10:05",
    readCount: 16240,
    hot: 68,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20recording%20studio%20with%20vintage%20microphone%20and%20warm%20wooden%20acoustic%20panels%2C%20soft%20amber%20mood%20lighting%2C%20no%20people%2C%20editorial%20photography&width=1200&height=675&seq=hl-music-cover&orientation=landscape",
    sections: [
      {
        heading: "授权链路上的三个角色",
        paragraphs: [
          "一首歌通常涉及词曲著作权与录音制作者权两套权利。翻唱现场若只是清唱并用于非商业场景，风险较低；一旦涉及商业演出、音像制品或公开传播，就需要取得相应授权。",
          "实际操作中，主办方、艺人与版权代理三方需要提前沟通，确认使用范围、期限与费用。任何一环缺失，都可能在使用后被要求下架。",
        ],
      },
      {
        heading: "普通听众不必焦虑",
        paragraphs: [
          "对普通听众来说，版权归属属于行业内部事务。了解基本概念有助于理性讨论，但不必因为一次下架就对作品或艺人做出过度评判。",
        ],
      },
    ],
  },
  {
    id: "relationship-timeline-0906",
    title: "同框照重新被翻出，时间线整理后发现只是巧合",
    summary:
      "两张拍摄时间相隔半年的同框照被放在一起后，引发新一轮猜测。我们按公开行程把时间线还原了一遍。",
    category: "relationship",
    categoryName: "情感瓜田",
    tags: ["时间线", "同框", "行程"],
    author: "吃瓜时间轴",
    date: "2026-09-06",
    time: "19:48",
    readCount: 34580,
    hot: 92,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20warm%20cafe%20interior%20with%20two%20empty%20chairs%20and%20hanging%20pendant%20lights%2C%20soft%20golden%20afternoon%20light%2C%20no%20people%2C%20editorial%20photography%20warm%20tones&width=1200&height=675&seq=hl-rel-cover&orientation=landscape",
    sections: [
      {
        heading: "时间线还原",
        paragraphs: [
          "第一张照片拍摄于春季的一场品牌活动，第二张来自秋季的机场路透。两者地点相距数百公里，中间隔了近半年。之所以被放在一起讨论，是因为服装色系接近。",
          "从公开行程看，两人在这半年内并无重合的活动记录。把照片的时间戳补全之后，「巧合」的解释更站得住脚。",
        ],
      },
      {
        heading: "为什么大家愿意相信巧合之外的版本",
        paragraphs: [
          "心理学上有个现象叫「聚簇错觉」：当两个相似的元素出现时，人会本能地在它们之间建立联系，即使数据上并不支持。社交平台的推荐机制会放大这类联想。",
          "面对类似话题，先找原始出处、再核对时间，是最省心的做法。",
        ],
      },
    ],
  },
  {
    id: "backstage-team-change-0906",
    title: "幕后团队换血？一份组讯里的制作班底变动解读",
    summary:
      "新项目公示的组讯中，摄影指导与美术指导均为新面孔。熟悉行业的人会知道，这类变动往往在立项阶段就已确定。",
    category: "backstage",
    categoryName: "幕后爆料",
    tags: ["班底", "组讯", "制作"],
    author: "幕后观察室",
    date: "2026-09-06",
    time: "13:12",
    readCount: 11020,
    hot: 55,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20film%20production%20desk%20with%20script%20pages%20and%20storyboard%20sketches%2C%20warm%20desk%20lamp%20light%2C%20no%20people%2C%20editorial%20still%20life%20photography%20amber%20tones&width=1200&height=675&seq=hl-backstage-cover&orientation=landscape",
    sections: [
      {
        heading: "班底变动意味着什么",
        paragraphs: [
          "摄影指导、美术指导属于项目的核心创作岗位，通常在筹备期就要确定。组讯公示的人选若与最初传闻不同，多数是筹备过程中的正常调整，而非成片质量问题。",
          "真正值得关注的是团队过往作品的风格是否与本次题材匹配。创作团队的适配度，往往比名气更能决定最终呈现。",
        ],
      },
      {
        heading: "看组讯的正确姿势",
        paragraphs: [
          "组讯是招募信息，涉及岗位众多，公示内容会随着筹备推进多次更新。建议以官方渠道的最终版本为准，不必对早期版本过度解读。",
        ],
      },
    ],
  },
  {
    id: "top-stream-data-0905",
    title: "一周数据复盘：谁在涨，谁在稳，谁在回温",
    summary:
      "过去一周的热度曲线出现了几次明显的交叉。我们用公开的讨论量做了一次简单的横向对比。",
    category: "top-stars",
    categoryName: "顶流追踪",
    tags: ["数据复盘", "趋势"],
    author: "数据看瓜",
    date: "2026-09-05",
    time: "09:30",
    readCount: 25610,
    hot: 79,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20data%20visualization%20with%20soft%20glowing%20curved%20lines%20on%20cream%20background%2C%20minimal%20editorial%20style%2C%20no%20people%2C%20amber%20and%20terracotta%20palette&width=1200&height=675&seq=hl-data-cover&orientation=landscape",
    sections: [
      {
        heading: "三位走势不同的样本",
        paragraphs: [
          "第一位因新剧物料发布，讨论量稳步上行，属于典型的作品驱动型增长。第二位的曲线保持平缓，说明日常曝光稳定但缺少爆点。第三位在沉寂数周后出现回升，通常与一条旧话题被重新提起有关。",
        ],
      },
      {
        heading: "数据能说明什么，不能说明什么",
        paragraphs: [
          "热度数据反映的是当下的话题浓度，不代表长期价值。把它当作观察窗口而非评判标准，会更接近事实。",
        ],
      },
    ],
  },
  {
    id: "film-tv-trailer-0905",
    title: "预告片放出三分钟，观众最在意的其实是这三个细节",
    summary:
      "新剧首支预告上线后，弹幕和短评区被反复讨论的并不是剧情，而是三个容易被忽略的制作细节。",
    category: "film-tv",
    categoryName: "影视剧透",
    tags: ["预告片", "细节", "服化道"],
    author: "看片不喊停",
    date: "2026-09-05",
    time: "21:16",
    readCount: 21340,
    hot: 74,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20cinema%20hall%20with%20empty%20dark%20seats%20and%20warm%20screen%20glow%2C%20moody%20amber%20lighting%2C%20no%20people%2C%20cinematic%20editorial%20photography&width=1200&height=675&seq=hl-trailer-cover&orientation=landscape",
    sections: [
      {
        heading: "细节一：色调与时代感",
        paragraphs: [
          "预告整体使用了偏暖的低饱和色调，配合自然光为主的布光，营造出年代质感。美术组在道具上做了做旧处理，避免了常见的「崭新感」。",
        ],
      },
      {
        heading: "细节二：剪辑节奏",
        paragraphs: [
          "三分钟里共出现多个转场，节奏前松后紧。这种结构通常用于在有限时长内交代人物关系，同时留出悬念。剪辑点之间的呼吸感，比台词密度更能体现成片的完成度。",
        ],
      },
      {
        heading: "细节三：声音设计",
        paragraphs: [
          "环境音被刻意放大，人声反而压低。这是近年剧集预告的流行做法，目的在强化沉浸感。是否成功，还要看成片能否延续这套声音逻辑。",
        ],
      },
    ],
  },
  {
    id: "variety-lineup-0904",
    title: "新一季阵容官宣：常驻与飞行名单里藏着节目走向",
    summary:
      "节目组一次性公布了整季嘉宾名单，常驻与飞行的比例出现变化。从排布方式能读出不少信息。",
    category: "variety",
    categoryName: "综艺风波",
    tags: ["阵容", "常驻", "飞行嘉宾"],
    author: "看片不喊停",
    date: "2026-09-04",
    time: "16:08",
    readCount: 14260,
    hot: 62,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20outdoor%20variety%20show%20set%20with%20wooden%20signs%20and%20warm%20string%20lights%20at%20dusk%2C%20no%20people%2C%20editorial%20photography%20amber%20and%20green%20tones&width=1200&height=675&seq=hl-lineup-cover&orientation=landscape",
    sections: [
      {
        heading: "常驻比例的变化",
        paragraphs: [
          "本季常驻嘉宾数量较上一季有所减少，飞行嘉宾的档期则更密集。这种安排一方面控制成本，另一方面也让每期主题更灵活。",
        ],
      },
      {
        heading: "从名单看内容方向",
        paragraphs: [
          "名单里出现了不少跨界嘉宾，说明节目在尝试拓宽受众。是否奏效，要看首期播出后的完播率与讨论方向。",
        ],
      },
    ],
  },
  {
    id: "live-refund-0904",
    title: "退货率数据被公开后，直播间选品逻辑要变了",
    summary:
      "一份行业报告披露了部分品类的退货率区间，让「冲销量」这套玩法面临重新审视。",
    category: "live",
    categoryName: "带货直播",
    tags: ["退货率", "选品", "行业"],
    author: "下单前先看",
    date: "2026-09-04",
    time: "12:44",
    readCount: 10580,
    hot: 53,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20packaging%20boxes%20and%20kraft%20paper%20on%20warm%20wooden%20floor%2C%20soft%20daylight%2C%20minimal%20editorial%20still%20life%2C%20no%20people%2C%20amber%20tones&width=1200&height=675&seq=hl-refund-cover&orientation=landscape",
    sections: [
      {
        heading: "高退货率背后的结构性问题",
        paragraphs: [
          "服饰与美妆的退货率长期偏高，原因包括色差、尺码预期落差以及冲动下单。直播间的强节奏话术会放大冲动消费，退货率随之上升。",
        ],
      },
      {
        heading: "选品思路的转向",
        paragraphs: [
          "越来越多团队开始把「留存」而非「单场GMV」作为核心指标，倾向选择复购率高的日用品。对消费者而言，这意味着直播间的推荐会逐渐回归实用。",
        ],
      },
    ],
  },
];

export const hotList = [
  { id: "relationship-timeline-0906", title: "同框照时间线还原：原来只是巧合", heat: 34200 },
  { id: "top-stream-drama-rumor-0909", title: "顶流新剧路透只剩背影却冲上热搜", heat: 31850 },
  { id: "variety-guest-edit-0909", title: "综艺正片删减争议，两种走向吵成两派", heat: 27640 },
  { id: "live-room-incident-0908", title: "直播间口误上热搜，选品团队回应", heat: 25110 },
  { id: "film-tv-trailer-0905", title: "预告片三分钟，观众最在意三个细节", heat: 22380 },
  { id: "fashion-cover-rotation-0908", title: "金九封面官宣，时尚资源排位悄悄变化", heat: 19920 },
];

export const dailyBrief = {
  date: "2026-09-10",
  issue: "第 286 期",
  lead: "今日份的瓜已整理完毕。编辑部从过去 24 小时的热门讨论里筛出 6 条值得一看的内容，按栏目归好类，三分钟就能读完。",
  highlights: [
    "顶流追踪：新剧进组第三天的路透讨论量持续走高",
    "综艺风波：正片与花絮的镜头差异引发对比热议",
    "时尚资源：金九封面陆续官宣，排位逻辑出现变化",
    "带货直播：退货率数据公开，选品思路开始转向",
  ],
};